export default ({ COLORS, FONT_SIZES }) => ({
  container: {
    border: '1px solid #EEE',
    borderRadius: '10px',
    ...FONT_SIZES.BODY_LARGE.STYLE,
    margin: '0 0 10px'
  },
  imgHolder: {
    width: '100px',
    height: '100px',
    borderRadius: '100px',
    margin: '25px 0 0',
    border: '1px solid #ECECEC',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  },
  primary: {
    '& $head': {
      backgroundColor: COLORS.BLUE.NORMAL
    }
  },
  secondary: {
    '& $head': {
      backgroundColor: COLORS.DARK_BLUE.NORMAL
    }
  },
  neutral: {
    '& $head': {
      backgroundColor: '#555'
    }
  },
  head: {
    transition: 'background-color 0.3s',
    display: 'flex',
    height: '76px',
    justifyContent: 'center',
    borderRadius: '10px 10px 0 0'
  }
})
